module.exports = __webpack_public_path__ + "img/img_tc_1.a1ad7202.png";